module.exports = __webpack_public_path__ + "img/logo.ef6bfbe8.png";